import {AIVendor, GenAIActionType, GenAIVendor} from './aiImages.enums';
import createIconsObj from '../../assets/icons/utils/createIconsObj';

const aiVendorLogos: Record<AIVendor, string> = createIconsObj(
  {
    [AIVendor.OpenAI]: '/openai-circle-logo.png',
    [AIVendor.StabilityAI]: '/stability-ai-circle-logo.png',
    [AIVendor.ClipDrop]: '/clipdrop-circle-logo.png',
    [AIVendor.Google]: '/openai-circle-logo.png',
  },
  'image-editor/vendors',
);

const aiVendorNames: Record<AIVendor, string> = {
  [AIVendor.OpenAI]: 'Open AI',
  [AIVendor.StabilityAI]: 'Stability AI',
  [AIVendor.ClipDrop]: 'Clipdrop',
  [AIVendor.Google]: 'Google',
};

const genAIActionTypeName: Record<GenAIActionType, string> = {
  [GenAIActionType.ImageToImageMasking]: 'Image to Image Masking',
  [GenAIActionType.UpscaleImage]: 'Upscale',
  [GenAIActionType.ReplaceBackground]: 'Replace Background',
  [GenAIActionType.RemoveBackground]: 'Remove Background',
  [GenAIActionType.SketchToImage]: 'Sketch to Image',
  [GenAIActionType.TextToImage]: 'Text to Image',
  [GenAIActionType.ChatCompletion]: 'Chat Completion',
  [GenAIActionType.GetEmbeddings]: 'Get Embeddings',
  [GenAIActionType.AudioTranscription]: 'Audio Transcription',
  [GenAIActionType.TextToSpeech]: 'Text to Speech',
  [GenAIActionType.Outpainting]: 'Outpainting',
  [GenAIActionType.Inpaint]: 'Inpaint',
  [GenAIActionType.PromptToImage]: 'Prompt to Image',
  [GenAIActionType.ImageAnalysis]: 'Image Analysis',
  [GenAIActionType.PromptToImageWithReferenceImages]: 'Prompt to Image with Reference Images',
  [GenAIActionType.ExtractTextLayers]: 'Extract Text Layers',
  [GenAIActionType.ProxyResponseApi]: 'Proxy Response API',
  [GenAIActionType.EditByPrompt]: 'Edit by Prompt',
};

const genAIVendorUiName: Record<GenAIVendor, string> = {
  [GenAIVendor.OpenAI]: 'Open AI',
  [GenAIVendor.StabilityAI]: 'Stability AI',
  [GenAIVendor.Clipdrop]: 'Clipdrop',
  [GenAIVendor.Anthropic]: 'Anthropic',
  [GenAIVendor.Google]: 'Google',
  [GenAIVendor.Runway]: 'Runway',
  [GenAIVendor.BriaAI]: 'Bria AI',
};

const INPAINT_LINE_COLOR = '#FA03EE';

const briaAIVendorService = 20;

export {
  aiVendorNames,
  aiVendorLogos,
  genAIActionTypeName,
  genAIVendorUiName,
  INPAINT_LINE_COLOR,
  briaAIVendorService,
};
